/**
 * List Schema of MotoristaMensagemPush
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {MotoristaMensagemPush} from '@/model/resource/MotoristaMensagemPush'

/* TODO: review generated schema */
export class ListMotoristaMensagemPushSchema extends Schema {
  readonly name = 'ListMotoristaMensagemPush'

  readonly fieldSet: FieldSet<MotoristaMensagemPush> = {
    idMensagemPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    mensagem: (): FieldComponent => ({
      is: Component.Render,
    }),
    data: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.data),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
    lida: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.lida),
      },
    }),
  }
}
